import React, { Component } from 'react';
import './SessionPolls.css';
import { connect } from 'react-redux';
import MultipleChoiceComponent from '../../../../../Components/MultipleChoiceComponent/MultipleChoiceComponent';
import EndOfPage from '../../../../../Components/EndOfPage/EndOfPage';
import PropTypes from 'prop-types';
import { ENGAGEMENT_DETAILS, POLLS_SEARCH } from '../../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import SimpleSearchBox from '../../../../../Components/SearchBox/SimpleSearchBox';
import { showGenericSkeletonScreen } from '../../../../../SkeletonScreens/SkeletonScreen';

export class SessionPolls extends Component {
  static propTypes = {
    reduced_session_polls: PropTypes.object,
    reduced_session_details: PropTypes.object,
    isBig: PropTypes.bool
  };
  static contextTypes = {
    t: PropTypes.func
  };
  constructor() {
    super();
    this.state = {
      textSearch: ''
    };
  }

  render() {
    const { fetching } = this.props.reduced_session_polls;
    return (
      <React.Fragment>
        <div className="sessionPollsEngagement">{this.searchComponent()}</div>
        <div className="engagementModalContent">
          {fetching ? (
            showGenericSkeletonScreen()
          ) : (
            <React.Fragment>
              {this.pollsListComponent()} <EndOfPage />
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );
  }
  searchComponent() {
    const { t } = this.context;
    return (
      <div className="sessionPollSearchBox">
        <SimpleSearchBox
          placeHolder={t('engagement.searchPollQuestions')}
          onSearchInputChange={textSearch => this.setState({ textSearch })}
          mixpanelData={{ action: ENGAGEMENT_DETAILS, searchType: POLLS_SEARCH }}
        />
      </div>
    );
  }

  pollsListComponent() {
    const { polls } = this.props.reduced_session_polls;
    const { stats } = this.props.reduced_session_details;
    const { isBig } = this.props;
    const filteredPolls = polls.filter(this.filterByText);

    return filteredPolls.map((poll, index) => (
      <MultipleChoiceComponent
        isBig={isBig}
        qAndAInfo={{
          ...poll,
          currentQuestionIndex: index + 1,
          totalQuestions: filteredPolls.length,
          totalAttendees: stats.attendees
        }}
        key={poll.dateAsked}
      />
    ));
  }
  filterByText = poll => {
    const { textSearch } = this.state;
    return (
      (poll && poll.question.toUpperCase().includes(textSearch.toUpperCase())) ||
      poll.responses.reduce((result, { text }) => {
        if (result === true) {
          return true;
        } else {
          return text.toUpperCase().includes(textSearch.toUpperCase());
        }
      }, false)
    );
  };
}

export default connect(state => ({
  reduced_session_polls: state.reduced_session_polls,
  reduced_session_details: state.reduced_session_details
}))(SessionPolls);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/SessionDetails/Engagement/EngagementModal/SessionPolls.js